<template>
  <div>
    RESPONSAVEIS
  </div>
</template>

<script>
export default {
  name: 'ResponsibleLink',

  props: {
    screen: {
      type: String,
      default: ''
    }
  },

  data: () => ({
  }),

  created() {
  },

  methods: {
  }
}
</script>